import { CreditCardProductCategory } from '@appTypes/EligibilityApi.interface'

const metaData: Record<
    CreditCardProductCategory,
    {
        description: string
        title: string
    }
> = {
    ['BalanceTransfer']: {
        title: 'Compare balance transfer credit cards and check your offers',
        description:
            'Compare balance transfer credit cards and move expensive debt to 0% interest. Check your eligibility and save money by paying off debt faster – with no impact on your credit score.',
    },

    ['BestCards']: {
        title: 'Compare credit cards and check your offers',
        description:
            'Compare credit cards and find your best match. Check your eligibility for balance transfer, purchase, cashback and travel cards – with no impact on your credit score.',
    },

    ['Cashback']: {
        title: 'Compare cashback credit cards and check your offers',
        description:
            'Compare cashback credit cards and earn money back on your spending. Check your eligibility and find cards that pay you to spend – with no impact on your credit score.',
    },

    ['Combined']: {
        title: 'Compare balance transfer and purchase credit cards',
        description:
            'Compare balance transfer and purchase credit cards to move debt and make new purchases with 0% interest. Check your eligibility and find dual cards – with no impact on your credit score.',
    },

    ['PoorCredit']: {
        title: 'Credit cards for bad credit - compare offers and build your score',
        description:
            'Compare cards for poor credit. Check your eligibility without impacting your score, with guaranteed offers to help you build your credit file.',
    },

    ['Purchase']: {
        title: 'Compare 0% purchase credit cards and check your offers',
        description:
            'Compare 0% purchase credit cards and spread the cost of big purchases without paying interest. Check your eligibility and find the best deals – with no impact on your credit score.',
    },

    ['Rewards']: {
        title: 'Compare rewards credit cards and check your offers',
        description:
            'Compare rewards credit cards and earn points or cashback on your spending. Check your eligibility with no impact on your credit score.',
    },

    ['Travel']: {
        title: 'Compare travel credit cards and check your offers',
        description:
            'Compare travel credit cards with no foreign fees. Save money abroad with better exchange rates – check your eligibility with no impact on your credit score.',
    },
}

export default metaData
